var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSignup(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 881 1080",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{isolation:isolate;}.cls-3{fill:#a3a3aa;}.cls-4{fill:#ededf7;}.cls-5{fill:#ea444c;}.cls-6{fill:#fff;}.cls-7{fill:#626266;}.cls-8{clip-path:url(#clip-path);}.cls-9{opacity:0.2;mix-blend-mode:multiply;}.cls-10{clip-path:url(#clip-path-2);}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 613.5,
    cy: 578.5,
    r: 22
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M288.27,548.78C291.32,423,390.09,402.79,411,399.91l0-.64s-149.47,7.3-152.1,148c-2.18,116.54,109,131.42,147.33,133.09C372.84,678.48,285.5,662.64,288.27,548.78Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "366 301 464 244 684 250 703 330 674 339 682 528 723 541 717 608 683.79 615.35 691.79 800 365.35 800 366 301"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "366 301 464 244 471 326 453 334 465 535 491 547 492 617 465 621 476.84 799.23 365 800 366 301"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "366 301 464 244 471 326 453 334 465 535 491 547 492 617 465 621 478 802 365 800 366 301"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "365.23 686.05 418.63 800.95 431.56 801.18 365.29 656.13 365.23 686.05"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "492 617 491 547 465 535 453 334 471 326 464 244 366 301 365.5 548.98 477.12 789.75 465 621 492 617"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M477,354l140.3.86a25.62,25.62,0,0,1,25.4,23.78l8.37,116.55a25.62,25.62,0,0,1-24.94,27.45L485,526Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "521.77 517.73 521.12 541 525 541 524.84 517.89 521.77 517.73"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M521.12,506.09s-6.46,1.94-3.88,9.05S527.59,521,529.53,519s4.52-7.76,1.93-11S525,504.15,521.12,506.09Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "513 389 515 407 528 408 526 386 513 389"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "609 389 607 407 594 408 596 386 609 389"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "516 439 530 439 530 453 515 454 516 439"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "529 452 543 452 543 466 528 467 529 452"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "542 466 594 464 594 478 541 481 542 466"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "621 437 607 437 607 451 622 452 621 437"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "608 450 594 450 594 464 609 465 608 450"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "481 324 551.45 324.66 472.19 252.51 481 324"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "553.8 252.97 489.95 251.43 570.79 324.84 624.6 325.35 553.8 252.97"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "499 552 500 616 711 604 717 547 499 552"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 541,
    y: 536,
    width: 13,
    height: 5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 517,
    y: 537,
    width: 13,
    height: 5
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "650.77 513.73 650.12 537 654 537 653.84 513.89 650.77 513.73"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M650.12,502.09s-6.46,1.94-3.88,9.05S656.59,517,658.53,515s4.52-7.76,1.93-11S654,500.15,650.12,502.09Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 646,
    y: 534,
    width: 13,
    height: 5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 559,
    y: 532,
    width: 13,
    height: 5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 626,
    y: 533,
    width: 13,
    height: 5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 607,
    y: 529,
    width: 13,
    height: 5
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "641 635 642 661 662 661 662 633 641 635"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M528.38,571.86s-8.83,2.57-5.3,12,14.13,7.71,16.78,5.14,6.19-10.27,2.65-14.55S533.68,569.3,528.38,571.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M688.41,563.79s-8.14,2.45-4.88,11.4,13,7.33,15.46,4.89,5.7-9.77,2.45-13.84S693.3,561.35,688.41,563.79Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 596.5,
    y: 535.5,
    width: 3,
    height: 91.01,
    transform: "translate(-6.35 6.61) rotate(-0.63)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 602.5,
    y: 535.5,
    width: 3,
    height: 91.01,
    transform: "translate(-6.35 6.67) rotate(-0.63)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 610.5,
    y: 535.5,
    width: 3,
    height: 91.01,
    transform: "translate(-6.35 6.76) rotate(-0.63)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 618.5,
    y: 535.5,
    width: 3,
    height: 91.01,
    transform: "translate(-6.35 6.85) rotate(-0.63)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 624.5,
    y: 535.5,
    width: 3,
    height: 91.01,
    transform: "translate(-6.35 6.91) rotate(-0.63)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 630.5,
    y: 535.5,
    width: 3,
    height: 91.01,
    transform: "translate(-6.35 6.98) rotate(-0.63)"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 651.5,
    y: 638.49,
    width: 3,
    height: 19.03,
    transform: "translate(-33.16 35.22) rotate(-3.01)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M724,800H154S398.74,850,724,800Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "396 356 413 731 436 727 417 347 396 356"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M412.3,398.25S261,405.46,258.38,546.19,420.56,679.51,420.56,679.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M416.48,398.47s-123.23,8.62-126.65,149.31S420.56,679.51,420.56,679.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M415,658.06a118.55,118.55,0,0,1-49-14.79c-22.37-12.77-49-39.41-49-93.81s24.85-85.8,45.7-102.65c22.59-18.25,45.51-23.74,45.74-23.79l.46,2a125.93,125.93,0,0,0-45,23.45C343.42,465,319,496,319,549.46c0,23.6,5.05,43.88,15,60.28a90.34,90.34,0,0,0,33,31.75,116.63,116.63,0,0,0,48.14,14.57Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M384.24,419.85C365.7,412.24,344.59,404.1,342,404v-4c4.18,0,37.19,13.45,43.76,16.15Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 332.21,
    y: 406.46,
    width: 4,
    height: 39.28,
    transform: "translate(-152.29 663.96) rotate(-77.95)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 314.5,
    y: 407.63,
    width: 4,
    height: 55.73,
    transform: "matrix(0.16, -0.99, 0.99, 0.16, -164.4, 677.52)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 308.5,
    y: 419.63,
    width: 2,
    height: 55.73,
    transform: "matrix(0.16, -0.99, 0.99, 0.16, -182.11, 680.67)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 293.5,
    y: 449.63,
    width: 2,
    height: 55.73,
    transform: "matrix(0.16, -0.99, 0.99, 0.16, -224.29, 691.02)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 284.5,
    y: 482.63,
    width: 2,
    height: 55.73,
    transform: "matrix(0.16, -0.99, 0.99, 0.16, -264.4, 709.81)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 283.5,
    y: 491.63,
    width: 2,
    height: 55.73,
    transform: "matrix(0.16, -0.99, 0.99, 0.16, -274.12, 716.37)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 283.5,
    y: 502.63,
    width: 2,
    height: 55.73,
    transform: "matrix(0.16, -0.99, 0.99, 0.16, -284.98, 725.6)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 254.63,
    y: 561.5,
    width: 55.73,
    height: 2,
    transform: "translate(-16.35 8.51) rotate(-1.68)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 263.63,
    y: 594.5,
    width: 55.73,
    height: 2,
    transform: "translate(-17.31 8.79) rotate(-1.68)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 277.63,
    y: 619.5,
    width: 55.73,
    height: 2,
    transform: "translate(-18.04 9.21) rotate(-1.68)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 286.63,
    y: 628.5,
    width: 55.73,
    height: 2,
    transform: "translate(-18.3 9.48) rotate(-1.68)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 311.63,
    y: 650.5,
    width: 55.73,
    height: 2,
    transform: "translate(-18.93 10.22) rotate(-1.68)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 292.5,
    y: 437.96,
    width: 4,
    height: 59.08,
    transform: "translate(-187.35 737.88) rotate(-87.09)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M306.8,502c-24.06-2.41-50.75-3.91-53.78-2.27L251,496.29c5.17-3.11,44.34.53,56.23,1.72Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 269.5,
    y: 526.26,
    width: 4,
    height: 37.48,
    transform: "translate(-309.93 725.76) rotate(-80.79)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 241.94,
    y: 584,
    width: 62.13,
    height: 4,
    transform: "matrix(1, -0.06, 0.06, 1, -37.2, 18.81)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 248.89,
    y: 605.5,
    width: 57.22,
    height: 4,
    transform: "translate(-52.04 26.58) rotate(-5.01)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 303.58,
    y: 619.66,
    width: 4,
    height: 49.16,
    transform: "translate(-341.61 943.53) rotate(-89.44)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 321.05,
    y: 657.5,
    width: 32.89,
    height: 4,
    transform: "translate(-201.15 150.87) rotate(-19.54)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M408.52,633.65l-.46-21c-12.6-2.45-24.29-8.34-34.8-17.52l-.93,19.12-15.33.57V566.31l29-2.11.23.79c.06.22,6.39,22,21.46,29.44l-1.05-48.14c-17.55-7.31-36.57-16.4-42.37-31.55-3.13-8.19-2.23-17.23,2.76-27.65,6.59-13.75,19.35-19.31,37.95-16.52l-.44-20,8.81-1.2.27,2-7,1,.45,20.63-1.2-.19c-18.26-3.05-30.71,2.07-37,15.22-4.74,9.89-5.62,18.42-2.7,26.07,5.58,14.57,24.54,23.47,41.87,30.66l.6.25,1.15,52.59-1.42-.6c-8.91-3.75-15-12.1-18.5-18.45a69.67,69.67,0,0,1-5.3-12.16L359,568.18v44.57l11.41-.42,1-21.52,1.58,1.44c10.85,9.94,23,16.19,36.18,18.59l.81.14.45,20.58,6.61-.25.08,2ZM408.23,529l-1.53-.86c-14.29-8-22-19.58-19.65-29.38,1.75-7.25,8.94-11.83,19.23-12.25l1,0Zm-2.88-40.43c-8.93.62-14.86,4.47-16.35,10.66-2.32,9.65,6.72,19.93,17.15,26.26Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 620.5,
    cy: 366.5,
    r: 4
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M620.5,371a4.5,4.5,0,1,1,4.5-4.5A4.51,4.51,0,0,1,620.5,371Zm0-8a3.5,3.5,0,1,0,3.5,3.5A3.5,3.5,0,0,0,620.5,363Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 635.5,
    y: 382.87,
    width: 4,
    height: 97.25,
    transform: "translate(-29.4 47.01) rotate(-4.13)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M534,589.3a8.8,8.8,0,1,1,8.8-8.8A8.81,8.81,0,0,1,534,589.3Zm0-16a7.2,7.2,0,1,0,7.2,7.2A7.21,7.21,0,0,0,534,573.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M693,580.8a8.8,8.8,0,1,1,8.8-8.8A8.81,8.81,0,0,1,693,580.8Zm0-16a7.2,7.2,0,1,0,7.2,7.2A7.21,7.21,0,0,0,693,564.8Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignup);
export default __webpack_public_path__ + "static/media/signup.4e3eeaf4c0d06b3774c3e2a6d287a717.svg";
export { ForwardRef as ReactComponent };